import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const SITE = "https://radiantmachinetools.com";

const META = {
  "/": {
    title: "Radiant Machine Tools | Precision Engineering & Manufacturing",
    desc: "Radiant Machine Tools provides precision engineering and manufacturing services including CNC machining, turning, milling, grinding, tooling, Dies and custom machined components in Telangana, India.",
  },
  "/about": {
    title: "About Us | Radiant Machine Tools",
    desc: "Radiant Machine Tools is a precision engineering and manufacturing company established in 1995 in Hyderabad, Telangana, manufacturing tooling, Dies, machined components and custom industrial parts to customer drawings.",
  },
  "/products": {
    title: "Products | Tooling, Dies & Machined Components | Radiant Machine Tools",
    desc: "Tooling, Dies, machined components, conveyor rollers, pulleys, jigs and fixtures, special purpose machines and custom components manufactured to customer drawings by Radiant Machine Tools, Hyderabad.",
  },
  "/capabilities": {
    title: "Capabilities | CNC Machining, Turning, Milling, Grinding | Radiant Machine Tools",
    desc: "CNC machining, turning, milling, grinding, surface grinding, tool and Die manufacturing and custom component manufacturing capabilities at Radiant Machine Tools, Hyderabad.",
  },
  "/industries": {
    title: "Industries Served | Radiant Machine Tools",
    desc: "Precision components, tooling and machined parts from Radiant Machine Tools support industrial manufacturing, engineering, tooling, machinery and automotive component applications.",
  },
  "/contact": {
    title: "Contact & Request a Quote | Radiant Machine Tools",
    desc: "Request a quote from Radiant Machine Tools — send your drawing or technical specification for tooling, Dies, machined components and custom parts. Hyderabad, Telangana.",
  },
};

const Seo = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    const meta = META[pathname];
    if (!meta) return;
    document.title = meta.title;

    const url = `${SITE}${pathname}`;

    let canonical = document.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement("link");
      canonical.setAttribute("rel", "canonical");
      document.head.appendChild(canonical);
    }
    canonical.setAttribute("href", url);

    const setMeta = (selector, attr, value) => {
      const el = document.querySelector(selector);
      if (el) el.setAttribute(attr, value);
    };
    setMeta('meta[name="description"]', "content", meta.desc);
    setMeta('meta[property="og:title"]', "content", meta.title);
    setMeta('meta[property="og:description"]', "content", meta.desc);
    setMeta('meta[property="og:url"]', "content", url);
    setMeta('meta[name="twitter:title"]', "content", meta.title);
    setMeta('meta[name="twitter:description"]', "content", meta.desc);
  }, [pathname]);

  return null;
};

export default Seo;
